import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import {
  DashboardSelectorDTO,
  DashboardConfigDTO,
} from '../../../dto/dashboard/dashboard.dto';
import { DashboardService } from '../../../services/dashboard/dashboard.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-dashboard-selector',
  templateUrl: './dashboard-selector.component.html',
  styleUrls: ['./dashboard-selector.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class DashboardSelectorComponent implements OnInit {
  availableDashboards$: Observable<DashboardSelectorDTO | null>;
  currentDashboard$: Observable<DashboardConfigDTO | null>;

  constructor(private dashboardService: DashboardService) {
    this.availableDashboards$ = this.dashboardService.getAvailableDashboards();
    this.currentDashboard$ = this.dashboardService.getCurrentDashboardConfig();
  }

  ngOnInit(): void {
    // No need to manually load - getAvailableDashboards() should handle this
  }

  /**
   * Handle dashboard selection change
   */
  onDashboardChange(dashboardId: string): void {
    this.dashboardService.setCurrentDashboard(dashboardId).subscribe();
  }

  /**
   * Create a new dashboard
   */
  createNewDashboard(): void {
    const newDashboard: DashboardConfigDTO = {
      id: '', // ID will be generated by the service
      name: 'Nyt dashboard',
      description: 'Brugerdefineret dashboard',
      widgets: [],
      isDefault: false,
    };

    this.dashboardService.createDashboard(newDashboard).subscribe();
  }

  /**
   * Set a dashboard as default
   */
  setAsDefault(dashboardId: string): void {
    this.dashboardService.setDefaultDashboard(dashboardId).subscribe();
  }

  /**
   * Reset to system default dashboard
   */
  resetToDefault(): void {
    this.dashboardService.resetToDefault().subscribe();
  }
}
